import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray, } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Enquiry } from 'src/app/models/messaging-models';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MessageService } from 'src/app/services/shared/message.service';
import { WebsocketService } from 'src/app/services/websocket.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ProductsService } from 'src/app/services/products.service';
import { I } from '@angular/cdk/keycodes';
import { ChangeDetectorRef } from '@angular/core';
import { OemService } from 'src/app/services/oem/oem.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { MatCardLgImage } from '@angular/material/card';
import { AllProductService } from 'src/app/services/shared/product-settings/all-products.service';


@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})

export class ChatComponent implements OnInit {
  @Input() messages: any[] = [];
  @ViewChild('fileInput') fileInput!: ElementRef;
  @Input() enquiryTabVisible: boolean = true


  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    // height: '3rem',
    minHeight: '0rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: '',
    defaultFontName: 'Arial',
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
    showToolbar: false,
  };

  messageObj: any;
  AllChats: { [key: string]: any } = {};
  chats: { [key: string]: any } = {};
  chatsMessage!: { [key: string]: any[] };
  chatMessages: any[] = [];
  allMessages: any[] = [];
  chatForm!: FormGroup;
  senderCheck: any;
  userName: any;
  isOem: boolean = false;
  userId: any;
  receiver1Id: any;
  receiver2Id: any;
  private messageSubscription!: Subscription;
  subscription: any;
  oemPersona: boolean = true;
  href: string = '';
  selectedChatItem!: string;
  uploadedFileUrl: string | null = null;
  uploadedFileName: string | null = null;
  companyDetailsMap: { [key: string]: any } = {};
  chatWith: string = '';
  prodId: string = '';
  productDetails: any;
  productImage: any;
  sendButton: boolean = false;
  activeTab: number = 0;
  previousTab: number = 0;
  showAdd: boolean = false;
  selectedProfile: any = null;
  sidebarVisible: boolean = false;
  filteredChats: any[] = [];
  groups: any[] = [];
  selecteChat: any;
  tab: number = 0;
  scheduleVisible: boolean = false;
  scheduleForm!: FormGroup;
  attendeeAdded: boolean = true;
  attendeeGroup: any;
  newEmail: FormControl = new FormControl();
  newName: FormControl = new FormControl();
  scheduleAttendees: any[] = [];
  attendeeGroups: string[] = [];
  attachedFiles: string[] = [];
  attachedFileUrls: string[] = [];
  fileArray: File[] = [];
  showWarning: boolean = false;
  allFiles: File[] = [];
  startDateControl = new FormControl();
  endDateControl = new FormControl();
  @ViewChild('picker') picker!: MatDateRangePicker<Date>;
  startdate: any;
  enddate: any;
  searchText: string = '';
  highlightedMessageIds: Set<string> = new Set();
  highlightedMessageElements: HTMLElement[] = [];
  currentHighlightIndex = -1;
  selectedGroup: any;
  groupSearchTexts: Map<string, string> = new Map();
  mediaCount: number = 0;
  docsCount: number = 0;
  documents: any[] = [];
  isLoadingMediaDocs: boolean = false;
  mediaItems: any[] = [];
  documentSizes: { [url: string]: string } = {};



  constructor(private localStorageService: LocalStorageService,
    private websocketService: WebsocketService,
    private messageService: MessageService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private productService: ProductsService,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private endCustomerService: EndCustomerService,
    private sweetAlertService: SweetAlertService,
    private spinnerService: SpinnerService,
    private oemService: OemService,
    private breadcrumbService: BreadcrumbService,
    private allProductService: AllProductService) {
    this.chatForm = new FormGroup({
      replymessage: new FormControl()
    });

    const state = window.history.state
    if (state?.enquiryTerm === 'Product Enquiry') {
      this.selectEnquiryType({ value: 'PRODUCT' });
    } else if (state?.enquiryTerm === 'Distributor Enquiry') {
      this.selectEnquiryType({ value: 'DISTRIBUTOR' });
    } else if (state?.enquiryTerm === 'General Enquiry') {
      this.selectEnquiryType({ value: 'GENERAL' });
    }

  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }
  openPicker(): void {
    this.picker.open();
  }

  ngOnInit(): void {
    this.breadcrumbService.setBreadcrumbs(['Dashboard', 'Enquiry Management']);
    this.receiver1Id = this.route.snapshot.params['id'];
    this.href = this.router.url;
    if (this.href?.split('/')?.indexOf('user') === 1) {
      this.oemPersona = false;
    }
    const roleName = localStorage.getItem('roleName') ?? '';

    this.userId = (roleName === 'USER' ? localStorage.getItem('userId') :
      roleName === 'OEM' ? localStorage.getItem('oemId') :
        roleName === 'DISTRIBUTOR' ? localStorage.getItem('distributorId') : '') ?? '';

    this.isOem = roleName === 'OEM' || roleName === 'DISTRIBUTOR' ? true : false;

    this.websocketService.joinChat(this.userId);
    this.websocketService.newMessageReceived.subscribe((msg: any) => {

      if (this.selecteChat.id === msg.senderId || this.selecteChat.groupName === msg.groupName) {
        this.chatMessages.push(msg);
        this.getChatsByUser(this.userId, this.startDateControl.value, this.endDateControl.value);
      }

    });
    const navigation = this.router.getCurrentNavigation();

    if (navigation?.extras?.state) {
      this.chatWith = navigation.extras.state['fromId'];
      this.prodId = navigation.extras.state['prodId'];
    } else {
      const state = window.history.state;
      this.chatWith = state['fromId'];
      this.prodId = state['prodId'];

      if (this.prodId) {
        this.getProductdetails(this.prodId)
      }
    }

    this.endDateControl.valueChanges.subscribe(end => {
      const start = this.startDateControl.value;

      if (start && end) {
        const formattedStart = this.formatDate(start,"start");
        const formattedEnd = this.formatDate(end,"end");
        this.getChatsByUser(this.userId, formattedStart, formattedEnd);
      }
    });
    this.getChatsByUser(this.userId, this.startDateControl.value, this.endDateControl.value);
    if (this.chatWith) {
      this.goToChatById(this.chatWith)

    }
    this.selectTab(0)

    // Reset search on route/group change
    this.searchText = '';
    this.highlightedMessageIds.clear();
    this.highlightedMessageElements = [];
    this.currentHighlightIndex = -1;

    const fromMessageId = history.state?.fromMessageId;
    if (fromMessageId) {
      setTimeout(() => {
        const element = document.getElementById('msg-' + fromMessageId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 0);
    }

  }

  selectEnquiryType(e: any) {
    this.enquiryType = e.value;
  }

  initializeForm() {
    this.scheduleForm = this.fb.group({
      subject: ['', Validators.required],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      attendees: this.fb.array([])
    });
  }
  formatDate(date: Date, type: string): string {
    const newDate = new Date(date);
    if(type === 'start'){
      newDate.setDate(newDate.getDate()); 
    } else if(type === 'end'){
      newDate.setDate(newDate.getDate() + 1); 
    } 
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(newDate);
    return formattedDate.split('/').reverse().join('-');
  }

  addAttendee() {
    if (this.newEmail.valid && this.newName.valid) {
      const attendeeGroup = this.createAttendee();
      attendeeGroup.patchValue({ email: this.newEmail.value, name: this.newName.value });
      this.attendees.push(attendeeGroup);
      this.clearInputFields();
    } else {
      this.sweetAlertService.showError('Error', 'Please enter valid email and name');
    }
  }

  add() {
    this.attendeeAdded = false;
    this.showAdd = false;
  }

  clear() {
    this.clearInputFields();
    this.attendeeAdded = true;
  }

  clearInputFields() {
    this.newEmail.reset();
    this.newName.reset();
  }

  toggleSidebar() {
    this.scheduleVisible = !this.scheduleVisible;
    this.newEmail = new FormControl('', Validators.required);
    this.newName = new FormControl('', Validators.required);
  }

  removeAttendee(index: number) {
    const attendeesArray = this.attendees;
    if (index > -1 && index < attendeesArray.length) {
      attendeesArray.removeAt(index);
    }
  }

  get attendees(): FormArray {
    return this.scheduleForm.get('attendees') as FormArray;
  }

  createAttendee(): FormGroup {
    return this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      name: ['', Validators.required]
    });
  }

  openProfile(senderId: string) {
    this.selectedProfile = this.companyDetailsMap[senderId];
    if (this.isOem) {

      this.sidebarVisible = true;
      this.scheduleVisible = false;
      this.attendeeAdded = true;
    }

  }

  closeSidebar() {
    this.sidebarVisible = false;
  }

  closescheduleSidebar() {
    this.scheduleVisible = false;
    this.attendeeAdded = true;
  }

  fetchCompanyDetails(senderId: string): Promise<void> {
    return this.messageService.getUserNameByUserId(senderId)
      .pipe(
        catchError(err => {

          return of({ statusCode: '500', message: 'Error retrieving data', data: null });
        })
      )
      .toPromise()
      .then(response => {
        if (response.statusCode === '200 OK' && response.data) {
          this.companyDetailsMap[senderId] = response.data;

        } else {

        }
      });
  }

  textInput() {
    const reqObj: any = {
      groupName: this.selecteChat.groupName,
      senderId: this.userId,
      receiverId: this.selecteChat.group ? this.selecteChat.id : this.selecteChat.receiverId,
      message: this.chatForm.value.replymessage,
      createdOn: new Date(),
      isGroup: this.selecteChat.group
    };

    this.chatForm.patchValue({ 'replymessage': null });
    this.allMessages.push(reqObj);
    this.chatMessages.push(reqObj);
    this.websocketService.sendPrivateMessage(reqObj);
  }

  attachmentInput() {
    const reqObj: any = {
      groupName: this.selecteChat.groupName,
      senderId: this.userId,
      receiverId: this.selecteChat.group ? this.selecteChat.id : this.selecteChat.receiverId,
      message: this.chatForm.value.replymessage || '', 
      attachments: [],
      createdOn: new Date(),
      isGroup: this.selecteChat.group
    };
  
    this.attachedFileUrls.forEach((url: string, i: number) => {
      const fileExtension = url?.split('.').pop()?.toLowerCase();
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'jfif'];
      if (imageExtensions.includes(fileExtension || '')) {
        reqObj.attachments.push(url);
      } else {
        reqObj.message += ` <br/><a href="${url}" target="_blank">${this.attachedFiles[i]}</a>`;
      }
    });
  
    this.chatForm.patchValue({ 'replymessage': null });
    this.attachedFileUrls = [];
    this.attachedFiles = [];
  
    this.allMessages.push(reqObj);
    this.chatMessages.push(reqObj);
    this.websocketService.sendPrivateMessage(reqObj);
  }
  

  sendMessage(): void {
    this.showWarning = false;
    const hasText = !!this.chatForm.get('replymessage')?.value;
    const hasAttachments = this.attachedFileUrls.length > 0;
  
    if (hasText && hasAttachments) {
      this.sendCombinedMessage();
    } else if (hasAttachments) {
      this.attachmentInput();
    } else if (hasText) {
      this.textInput();
    }
  
    this.getChatsByUser(this.userId, this.startDateControl.value, this.endDateControl.value);
  }
  

  sendCombinedMessage(): void {
    const reqObj: any = {
      groupName: this.selecteChat.groupName,
      senderId: this.userId,
      receiverId: this.selecteChat.group ? this.selecteChat.id : this.selecteChat.receiverId,
      message: this.chatForm.value.replymessage,
      attachments: [],
      createdOn: new Date(),
      isGroup: this.selecteChat.group
    };
  
    this.attachedFileUrls.forEach((url: string, i: number) => {
      const fileExtension = url?.split('.').pop()?.toLowerCase();
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'jfif'];
      if (imageExtensions.includes(fileExtension || '')) {
        reqObj.attachments.push(url);
      } else {
        reqObj.message += ` <br/><a href="${url}" target="_blank">${this.attachedFiles[i]}</a>`;
      }
    });
  
    this.chatForm.patchValue({ 'replymessage': null });
    this.attachedFileUrls = [];
    this.attachedFiles = [];
  
    this.allMessages.push(reqObj);
    this.chatMessages.push(reqObj);
    this.websocketService.sendPrivateMessage(reqObj);
  }
  


  goToChatById(id: string): void {
    this.initializeForm();

    const chat = this.chats[id];
   

    this.selectedChatItem = id;

    this.attachedFileUrls = []
    this.attachedFiles = []
    this.chatForm?.get('replymessage')?.setValue('')
    this.fileArray = [];
    this.showWarning = false;

    this.selecteChat = this.chats[id];
    if (chat.group && chat.groupMembers) {
      // Clear existing attendees first
      this.clearAttendees();

      // Fetch details of each group member and add them to attendees
      chat.groupMembers.forEach((memberId: string) => {
        this.fetchCompanyDetails(memberId).then(() => {
          const attendeeData = this.companyDetailsMap[memberId];
          if (attendeeData) {
            this.addGroupAttendee(attendeeData.email, attendeeData.name);
          }
        });
      });
    }
    if (chat.group) {
      this.getMessagesByGroup(id);
    } else {

      this.getMessagesByNonGroup(this.userId, id);
    }
    this.sidebarVisible = false;
    this.scheduleVisible = false;
  }

  addGroupAttendee(email: string, name: string) {
    const attendeeGroup = this.createAttendee();
    attendeeGroup.patchValue({ email, name });
    this.attendeeGroups.push(attendeeGroup.value.email);



    this.attendees.push(attendeeGroup);

  }

  clearAttendees() {
    while (this.attendees.length !== 0) {
      this.attendees.removeAt(0);
    }
  }

  getMessagesByNonGroup(userId1: string, userId2: string): void {
    this.messageService.getMessagesByNonGroup(userId1, userId2).subscribe(data => {
      this.chatMessages = data.data.messages;
      const uniqueSenderIds = new Set<string>();
      this.chatMessages.forEach(message => {
        uniqueSenderIds.add(message.senderId);
      });

      const fetchDetailsPromises = Array.from(uniqueSenderIds).map(senderId => this.fetchCompanyDetails(senderId));
      Promise.all(fetchDetailsPromises).then(() => {

      });
    });
  }

  enquiryType: string = 'All';
  getChatIds(type: string): string[] {

    let lstt;
    if (type === 'All' || this.enquiryType === 'All') {
      lstt = Object.keys(this.chats);
    }
    else {
      lstt = Object.keys(this.chats).filter(id => this.chats[id]?.enquiryType === type);
    }
    return lstt;
  }

  getRandomColor(seed: string): string {
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
      hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = Math.floor((Math.abs(Math.sin(hash) * 16777115)) % 16777115).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  removeUploadedFile(i: number): void {
    this.showWarning = false;
    this.attachedFiles = this.attachedFiles.filter((data: any, id: number) => i !== id)
    this.attachedFileUrls = this.attachedFileUrls.filter((data: any, id: number) => i !== id);
    this.uploadedFileUrl = null;
    this.uploadedFileName = null;
    // this.chatForm.patchValue({ 'replymessage': null });
  }

  uploadPhoto(event: any, isDragAndDrop: boolean): void {
    event.preventDefault();
    const input = event.target as HTMLInputElement;
    const file: FileList = (isDragAndDrop) ? event.dataTransfer.files : event.target.files;
    if (file) {
      this.fileArray = Array.from(file);
      this.allFiles = this.fileArray
      if (this.fileArray.length > 10) {
        this.showWarning = true;
        this.fileArray = this.fileArray.splice(0, 10);
      } else if (this.attachedFileUrls.length + this.fileArray.length > 10) {
        this.showWarning = true;
        return;
      }
      this.fileArray.forEach((file: File) => {
        this.uploadedFileName = file.name;
        this.attachedFiles.push(file.name);
        const uploadData = new FormData();
        uploadData.append('file', file);
        const randomNumber = Math.floor(Math.random() * 10) + 1;
        uploadData.append('destinationKey', randomNumber.toString());

        this.endCustomerService.executePostRequestForAuth(MweConstants.uploadFile, uploadData)
          .subscribe(data => {
            if (data && data?.data) {
              this.uploadedFileUrl = data.data;
              this.attachedFileUrls.push(data.data)
              input.value = '';
            }
          }, error => {

          });
      })
    }
  }

  onDragOver(event: any) {
    event.preventDefault();
  }
  searchTerm: string = '';
  filterByGroupName(event: any): void {

    this.searchTerm = event.target.value.toLowerCase();

    if (this.startDateControl.value && this.endDateControl.value) {
      const formattedStart = this.formatDate(this.startDateControl.value,"start");
      const formattedEnd = this.formatDate(this.endDateControl.value,"end");
      this.getChatsByUser(this.userId, formattedStart, formattedEnd);
      return;
    }
    this.getChatsByUser(this.userId, this.startDateControl.value, this.endDateControl.value);



  }




  getNotGroupsByUser(userId: string): void {
    this.messageService.getConversationWithUser(userId)
      .subscribe(data => {
        data.data.forEach((id: string) => {
          this.chats[id] = { id, isGroup: false };

        });
      }, error => {

      });
  }

  getProductdetails(id: string | null) {
    if (id === null) {
      return;
    }
    this.productService.getProductById(id).subscribe((res: any) => {
      this.productDetails = res.data;

      const images = res.data.productInfoDTO?.images;
      if (images && images.length) {
        this.productImage = images[0];
      }


    });
  }


  getMessagesByGroup(groupId: string, groupName?: string): void {
    this.searchText = '';
    this.highlightedMessageIds.clear();
    this.highlightedMessageElements = [];
    this.currentHighlightIndex = -1;

    this.selecteChat = this.chats[groupId];
    this.selectedChatItem = groupId;

    this.messageService.getMessagesByGroup(groupId, '', groupName).subscribe(data => {
      this.chatMessages = data.data.messages;
      this.mediaCount = data.data.mediaCount;
      this.mediaItems = data.data.mediaList;
      this.docsCount = data.data.documentCount;
      this.documents = data.data.documentList;
      const uniqueSenderIds = new Set<string>();
      this.chatMessages.forEach(message => {
        uniqueSenderIds.add(message.senderId);
      });

      const fetchDetailsPromises = Array.from(uniqueSenderIds).map(senderId =>
        this.fetchCompanyDetails(senderId)
      );
      Promise.all(fetchDetailsPromises).then(() => {
      });
    });
  }


  onSearchMessage(): void {
    this.highlightedMessageIds.clear();
    this.highlightedMessageElements = [];
    this.currentHighlightIndex = -1;

    const keyword = this.searchText.trim().toLowerCase();
    if (!keyword) return;

    const filePattern = /\.(jpg|jpeg|png|gif|webp|svg|csv|xlsx|xls|jpe)$/i;
    const urlPattern = /^https?:\/\/.*\.(jpg|jpeg|png|gif|webp|svg|csv|xlsx|xls|jpe)(\?.*)?$/i;
    this.chatMessages.forEach(message => {
      const msgText = message.message?.trim();
      if (!msgText) return;
      const tempElement = document.createElement('div');
      tempElement.innerHTML = msgText;
      const visibleText = tempElement.textContent?.trim().toLowerCase() || '';

      const containsKeyword = visibleText.includes(keyword);
      const isFileOnly = filePattern.test(msgText) || urlPattern.test(msgText);

      if (containsKeyword && !isFileOnly) {
        this.highlightedMessageIds.add(message.id);
      }
    });
    setTimeout(() => {
      this.highlightedMessageElements = Array.from(document.querySelectorAll('.highlighted')) as HTMLElement[];
      if (this.highlightedMessageElements.length > 0) {
        this.currentHighlightIndex = 0;
        this.scrollToHighlighted();
      }
    }, 0);
  }

  scrollToHighlighted(): void {
    const el = this.highlightedMessageElements[this.currentHighlightIndex];
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  onEnterKeyPress(): void {
    if (this.highlightedMessageElements.length === 0) return;
    this.currentHighlightIndex = (this.currentHighlightIndex + 1) % this.highlightedMessageElements.length;
    this.scrollToHighlighted();
  }
  onGroupChange(newGroup: any): void {
    this.selectedGroup = newGroup;
    this.searchText = '';
    this.highlightedMessageIds.clear();
    this.highlightedMessageElements = [];
    this.currentHighlightIndex = -1;
  }
  getChatsByUser(userId: string, startDate: string, endDate: string): void {
    this.messageService.getConversationsById(userId, startDate, endDate, this.searchTerm).subscribe((data: any) => {
      this.chats = {};
      data.data.forEach((chat: any) => {
        this.AllChats[chat.id] = chat;
        this.chats[chat.id] = chat;
        if (!chat.group) this.fetchCompanyDetails(chat.id);
      });

      if (this.chatWith) {
        if (this.prodId) {
          this.chatForm.patchValue({
            'replymessage': `<img src="${this.productImage}" alt="${this.productDetails.productInfoDTO.name}" /> <br /> ${this.productDetails.productInfoDTO.name}`
          });
        }
        this.getMessagesByGroup(this.chatWith);
      }
    });
  }


  selectTab(index: number): void {
    if (index !== this.activeTab) {
      this.previousTab = this.activeTab;
      this.activeTab = index;
      this.chats = Object.values(this.AllChats).reduce((acc: any, chat: any) => {
        acc[chat.id] = chat;
        return acc;
      }, {});


    }
  }



  mediaTab() {
    this.tab = 0;
  }
  documentsTab() {
    this.tab = 1;
  }

  scheduleMeeting() {
    this.scheduleVisible = true;
  }

  save() {

    this.spinnerService.showSpinner();

    if (this.scheduleForm.invalid) {
      const invalidFields = Object.keys(this.scheduleForm.controls)
        .filter(control => this.scheduleForm.get(control)?.invalid)
        .map(control => control.charAt(0).toUpperCase() + control.slice(1));

      this.spinnerService.hideSpinner();
      if (invalidFields.length > 1) {
        this.sweetAlertService.showError('Error', 'Please fill all the fields');
      } else if (invalidFields.length === 1) {
        this.sweetAlertService.showError('Error', `Please fill the field: ${invalidFields[0]}`);
      }
      return;
    }
    const formValue = this.scheduleForm.value;
    const startTime = new Date(formValue.startTime).toISOString();
    const endTime = new Date(formValue.endTime).toISOString();

    const formattedFormValue = {
      ...formValue,
      startTime: startTime,
      endTime: endTime
    };


    this.oemService.createMeeting(formattedFormValue).subscribe((res: any) => {

      this.spinnerService.hideSpinner();
      this.sweetAlertService.showSuccess('Success', 'Meeting Scheduled Successfully');
    }, error => {

      this.spinnerService.hideSpinner();
      this.sweetAlertService.showError('Error', 'Failed to schedule meeting');
    });
  }

  getMessagePreview(message: string | undefined): string {
    if (!message) return '';

    const hasImage = /<img\s+[^>]*src=["'][^"']+["'][^>]*>/i.test(message);
    const hasFileLink = /<a\s+[^>]*href=["'][^"']+\.(pdf|docx?|xlsx?|zip|rar|pptx?)["'][^>]*>/i.test(message);

    if (hasImage) return 'Image';
    if (hasFileLink) return 'File';

    const text = message.replace(/<[^>]*>?/gm, '').trim();

    return text;
  }

  formatDatetype(timestamp: number | undefined): string {
    if (!timestamp) return '';
    const now = new Date();
    const date = new Date(timestamp);
    const isToday =
      date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear();
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);

    const isYesterday =
      date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();

    if (isToday) {
      return date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    }

    if (isYesterday) {
      return 'Yesterday';
    }

    return date.toLocaleDateString(undefined, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
  clearDateRange(event: Event) {
    event.stopPropagation();
    this.startDateControl.setValue(null);
    this.endDateControl.setValue(null);
    this.getChatsByUser(this.userId, '', '');
  }


  onGroupClick(group: any): void {
    this.getMessagesByGroup(group.id, group.groupName);
  }

  getFormattedName(name: string): string {
    if (!name) return '';
  
    const fileName = name.substring(name.lastIndexOf('/') + 1);
  
    return fileName.replace(/^\d+/, '');
  }
  
  isFile(name: string): boolean {
    return name?.toLowerCase().endsWith('.pdf') || name?.toLowerCase().endsWith('.csv');
  }


}